import useSetSelectedChoices from "../criteria/choices/useSetSelectedChoices";
import { flattenCriteria } from "../utils";
import { criteriaGroupsType } from "../../common/types/search/search";

export const SelectedChoicesInitializer = ({
	criteria,
}: {
	criteria: criteriaGroupsType;
}) => {
	useSetSelectedChoices(flattenCriteria(criteria));

	return null;
};
